<form [formGroup]="form" *ngIf="entity && entity.visibleToUser" novalidate>
  <ng-container *ngIf="orientation === 'horizontal'">
    <div
      class="form-group d-flex align-items-center"
      [ngClass]="{ 'mb-0': !showLabel }"
    >
      @if(!templateForPermitForm){
      <label
        *ngIf="showLabel"
        [for]="entity.templateCode"
        class="mr-3 mb-0 d-flex align-items-center"
        style="height: 38px;"
        [ngClass]="{ 'font-weight-bold': entity.isRequired }"
        >{{ entity.label }}</label
      >
      <div class="flex-shrink-0" style="width: 200px;">
        <input
          *ngIf="!entity.isCalculating"
          type="text"
          [readonly]="!entity.allowEdit"
          [ngClass]="inputClass"
          [formControlName]="entity.templateCode"
          [(ngModel)]="this.modelValue"
          [name]="entity.templateCode"
          [id]="entity.templateCode"
        />
        <app-loader *ngIf="entity.isCalculating"></app-loader>
      </div>
      } @else {
      <wm-common-textfield
        *ngIf="!entity.isCalculating"
        [data]="{
      label: showLabel?entity.label: '',
      id: entity.templateCode,
      value: this.modelValue,
      readonly: !entity.allowEdit,
      required: entity.isRequired && entity.allowEdit,
    }"
        [formControlName]="entity.templateCode"
        (valueChange)="this.modelValue = $event"
      >
      </wm-common-textfield>
      }
    </div>
  </ng-container>
  <ng-container *ngIf="orientation === 'vertical'">
    <div [ngClass]="divClass">
      @if(!templateForPermitForm){
      <wm-de-label
        *ngIf="showLabel"
        [entity]="entity"
        [displayOnly]="!entity.allowEdit"
        [for]="entity.templateCode"
      ></wm-de-label>
      <input
        *ngIf="!entity.isCalculating"
        type="text"
        [readonly]="!entity.allowEdit"
        [ngClass]="inputClass"
        [formControlName]="entity.templateCode"
        [(ngModel)]="this.modelValue"
        [name]="entity.templateCode"
        [id]="entity.templateCode"
      />

      } @else {
      <wm-common-textfield
        *ngIf="!entity.isCalculating"
        [data]="{
      label: showLabel?entity.label: '',
      id: entity.templateCode,
      readonly: !entity.allowEdit,
      value: this.modelValue,
      required: entity.isRequired && entity.allowEdit,
    }"
        [formControlName]="entity.templateCode"
        (valueChange)="this.modelValue = $event"
      >
      </wm-common-textfield>
      }
      <app-loader *ngIf="entity.isCalculating"></app-loader>
    </div>
  </ng-container>
</form>
